var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"psPageNotFound"},[_vm._v(" pagina no encontrada ")])
}
var staticRenderFns = []

export { render, staticRenderFns }